import { MARKS } from '@hotjar/webapp/performance';
import { mark, measureAndLog } from '@hotjar/performance';
import { Segment } from '@hotjar/global-filters/src/domains/global-filters/model/segment';
import { fetchSegments, getCachedSegments } from './fetchSegments';
import { getSegmentById } from './getSegmentById';
import { getPlaybacks } from './getPlaybacks';

import type { Site } from '@hotjar/site';
import { convertFromNewUiToQueryFormat, readFiltersFromUrl } from '@hotjar/global-filters';
import type { Store } from '../../../store/list/types';

/**
 * Get the segments available for this site.
 */
export const getSegments = async (store: Store): Promise<void> => {
  mark(MARKS.RECORDINGS_LIST_SEGMENTS_FETCH_START);

  const { site, setJsonFilters, setLoaded, setSegments, setCurrentSegment } = store.getState();

  let segmentArray = getCachedSegments(site as Site);
  if (!segmentArray) {
    try {
      segmentArray = await fetchSegments(site as Site);
    } catch {
      segmentArray = [];
    }
  }

  // Perf: Measure how long it took to fetch the segments
  measureAndLog({
    name: MARKS.RECORDINGS_LIST_SEGMENTS_FETCH_TIME,
    startMark: MARKS.RECORDINGS_LIST_SEGMENTS_FETCH_START,
    addMark: true,
  });
  const { filtersInUiFormat } = readFiltersFromUrl(segmentArray);
  setJsonFilters(convertFromNewUiToQueryFormat(filtersInUiFormat));
  setSegments(segmentArray);

  const searchParams = new URLSearchParams(window.location.search);
  const hasFiltersInUrl = searchParams.get('filters');

  if (!hasFiltersInUrl) {
    const currentSegmentId = parseInt(searchParams.get('segment') || '', 10) || -1;
    setCurrentSegment(getSegmentById(currentSegmentId, segmentArray) as Segment);
  }

  await getPlaybacks(store, true);
  setLoaded(true);
};
